import {capitalize} from '@mui/material';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingSummary} from 'presentation/modules/booking/shared/hooks/useBookingSummary';
import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import getFormattedHour from 'presentation/modules/booking/shared/utils/getFormattedHour';
import {useMediaQueries} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import {formatDateWithWeekday} from 'presentation/utils';

const {at} = translations['pt-br'].commons;

export function useTelehealthReviewBooking() {
	const bookingData = useBookingStore(state => state.bookingData);
	const {handleChangeModals} = useBookingSummary();
	const {day, weekday, month} = formatDateWithWeekday(bookingData.dateAt);
	const {iconName} = useBookingTheme({flowType: FlowEnum.TELEHEALTH});
	const {isLaptop, isMobile, isTablet} = useMediaQueries();
	const activeBookingFlowStep = useBookingFlowStepsStore(state => state.bookingStep);

	const formattedHour = getFormattedHour(bookingData.hourAt, FlowEnum.TELEHEALTH);
	const formattedDateAndHour = `${capitalize(weekday)}, ${bookingData.dateAt} ${at} ${formattedHour}`;

	const isRebooking = bookingData.isRebooking;

	return {
		bookingData,
		day,
		month,
		formattedDateAndHour,
		isRebooking,
		handleChangeModals,
		iconName,
		isLaptop,
		isMobile,
		isTablet,
		activeBookingFlowStep,
	};
}
